import { Package } from "lucide-react";
import { useState } from "react";

type Props = {
  iconUrl?: string;
};

export function ItemThumbnail({ iconUrl }: Props) {
  const [failedUrl, setFailedUrl] = useState<string>();
  const shouldShowImage = Boolean(iconUrl) && failedUrl !== iconUrl;

  return (
    <span
      className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-[10px] bg-[var(--color-primary-soft)] text-[var(--color-primary)]"
      aria-hidden="true"
      data-item-thumbnail={shouldShowImage ? "image" : "fallback"}
    >
      {iconUrl && shouldShowImage ? (
        <img
          src={iconUrl}
          alt=""
          loading="lazy"
          referrerPolicy="no-referrer"
          className="h-full w-full object-cover"
          onError={() => setFailedUrl(iconUrl)}
        />
      ) : (
        <Package size={20} />
      )}
    </span>
  );
}
